import { createI18n } from "vue-i18n";
import messages from "src/i18n";

export default ({ app }) => {
  // Create I18n instance
  const i18n = createI18n({
    locale: "en-GB",
    messages,
  });
  app.use(i18n);
};
